import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { push, CallHistoryMethodAction } from 'connected-react-router';

import { Translate } from 'react-localize-redux';

import SubscriptionItemComponent from '../subscription-item';
import {
  EntitySubscription,
  ListSubscriptionsResponse,
  SubscriptionItem,
} from '@common/types/subscription-manager/list-subscriptions-response';
import moment from 'moment';

interface SubscriptionsItemListCtrlProps {
  className?: string;
  subscription: EntitySubscription;
  category: keyof ListSubscriptionsResponse;
  goToPlans: (
    category: keyof ListSubscriptionsResponse,
    clientId: string,
    id: string
  ) => CallHistoryMethodAction;
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  goToPlans: (
    category: keyof ListSubscriptionsResponse,
    clientId: string,
    id: string
  ) => {
    if (category === 'recordLabels') {
      return dispatch(push(`/plans-record-label/0/${clientId}/${id}`));
    }
    return dispatch(push(`/plans/${clientId}/${id}`));
  },
});

const SubscriptionsItemListCtrl: React.FC<SubscriptionsItemListCtrlProps> = ({
  className,
  subscription,
  category,
  goToPlans,
}) => {
  const getText = (item: SubscriptionItem) => {
    if (!item.isActive) {
      return <Translate id="USER_PROFILE.SUBSCRIPTION.EXPIRED" />;
    }
    if (item.isExpiring) {
      return (
        <>
          <Translate id="USER_PROFILE.SUBSCRIPTION.EXPIRING_ON" />{' '}
          {moment(item.endsAt).format('LL')}
        </>
      );
    }

    return (
      <>
        <Translate id="USER_PROFILE.SUBSCRIPTION.NEXT_BILL" />{' '}
        {moment(item.nextBilling).format('LL')}
      </>
    );
  };

  // const getBtnText = (hasSubscription: boolean) => {
  //   if (hasSubscription) {
  //     return 'USER_PROFILE.SUBSCRIPTION.BTN.MANAGE';
  //   }
  //   return 'USER_PROFILE.SUBSCRIPTION.BTN.SUBSCRIBE';
  // };

  return (
    <div className={`${className || ''}`}>
      {subscription.subscriptions.map((item) => (
        <SubscriptionItemComponent
          key={item.id}
          isActive={item.isActive}
          badge={item.type !== 'merch' ? item.plan : ''}
          title={
            item.type === 'merch' ? (
              <Translate id="USER_PROFILE.SUBSCRIPTION.MERCH.TITLE" />
            ) : (
              <Translate id="USER_PROFILE.SUBSCRIPTION.DISTRIBUTION.TITLE" />
            )
          }
          text={getText(item)}
          // btnText={<Translate id={getBtnText(item.isActive)} />}
          onClick={() => goToPlans(category, subscription.id, item.id)}
          isExpiring={item.isExpiring}
        />
      ))}
      {!subscription.subscriptions.length ? (
        <SubscriptionItemComponent
          isActive={true}
          badge={category === 'artists' ? 'Beginner' : 'Team'}
          title={
            <Translate id="USER_PROFILE.SUBSCRIPTION.DISTRIBUTION.TITLE" />
          }
          text={''}
          // btnText={<Translate id={getBtnText(false)} />}
          onClick={() => goToPlans(category, subscription.id, '')}
          isExpiring={false}
        />
      ) : null}
    </div>
  );
};

export default connect(null, mapDispatchToProps)(SubscriptionsItemListCtrl);
